import sortByCreatedAtDesc from '../../data_management/sorters/sort_by_created_at_desc';
import StartInvestigationController from '../modals/start_investigation_controller';
import ManageInvestigationController from '../modals/manage_investigation_controller';
import { Loader } from '../common/loader';

const OpenInvestigations = function ($scope, $element, $location, initialDataInteractor, emailInteractor,
                                     ModalService, investigationInteractor, eventsService) {
  const $ctrl = this;
  $ctrl.sortedInvestigations = [];

  $ctrl.$onInit = function() {
    // $ctrl.loader = new Loader($element[0]); // No promise around to close the loader after data load!
  };

  $ctrl.$onChanges = function () {
    if ($ctrl.investigations) $ctrl.sortInvestigations();
  };

  $ctrl.sortInvestigations = function () {
    $ctrl.sortedInvestigations = $ctrl.investigations.sort(sortByCreatedAtDesc)
      .filter(investigation => investigation.is_open)
      .slice(0, 50);
  };

  $ctrl.clickedActions = function (investigation) {
    return new Promise(resolve => {
      ModalService.showModal({
        templateUrl: 'modals/manage_investigation.html',
        controllerAs: '$ctrl',
        controller: ManageInvestigationController,
        inputs: {
          investigation: investigation,
          investigationInteractor: investigationInteractor,
          eventsService: eventsService,
          emailInteractor: emailInteractor,
        }
      }).then(modal => {
        modal.close.then(() => resolve());
      });
    });
  };

  $ctrl.closeInvestigation = function (investigation) {
    return investigationInteractor.lockInvestigation(investigation)
      .then(() => {
        $ctrl.sortInvestigations();
        $ctrl.updateInvestigations();
      });
  };

  $ctrl.startInvestigation = function () {
    return new Promise(resolve => {
      ModalService.showModal({
        templateUrl: 'modals/start_investigation.html',
        controllerAs: '$ctrl',
        controller: StartInvestigationController,
        inputs: {
          initialDataInteractor: initialDataInteractor,
          eventsService: eventsService,
          emailInteractor: emailInteractor,
          workspaceId: $ctrl.workspaceId
        }
      }).then(modal => {
        modal.close.then(() => {
          $ctrl.updateInvestigations();
          resolve();
        });
      })
    })
  };

  $ctrl.clickedLeftSection = function (investigation) {
    $scope.$applyAsync(() => $location.path(`/investigation/${investigation.id}`));
  };

  $ctrl.canStartInvestigation = function () {
    return !!$ctrl.workspaceId;
  }
};

export default {
  name: 'openInvestigations',
  obj: {
    controller: OpenInvestigations,
    templateUrl: 'components/open_investigations.html',
    bindings: {
      investigations: '<',
      workspaceId: '<',
      updateInvestigations: '&'
    }
  }
}